/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit, IconEye } from '@tabler/icons-react';
import DeleteConfirmPopover from '../../../../../components/DeleteConfirmPopover';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import { Permission } from '../../../../../models/core/departments.type';
import { ResidueType } from '../../../../../models/core/residues.type';
import theme from '../../../../../theme';
import { validate } from '../../../../../utils/permission.utils';

type DataViewActionProps = {
  item: ResidueType;
  confirmActionResult(item: ResidueType, action: string, confirmed: boolean): void;
};

export default function DataViewActions(props: DataViewActionProps) {
  const [currentUser] = useCurrentUser();

  return (
    <Group>
      {validate(Permission.ResidueView, currentUser.permissoes) && (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Visualizar">
          <ActionIcon
            size="sm"
            radius="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.primary?.[6] }}
            variant="outline"
            onClick={() => {
              props.confirmActionResult(props.item, 'visualizar', true);
            }}
          >
            <IconEye size={15} color={theme?.colors?.primary?.[6]} />
          </ActionIcon>
        </Tooltip>
      )}
      {validate(Permission.ResidueEdit, currentUser.permissoes) && (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Editar">
          <ActionIcon
            size="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.accent?.[6] }}
            variant="outline"
            onClick={() => {
              props.confirmActionResult(props.item, 'editar', true);
            }}
          >
            <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
          </ActionIcon>
        </Tooltip>
      )}
      {validate(Permission.ResidueDelete, currentUser.permissoes) && (
        <DeleteConfirmPopover
          label="Excluir"
          message="Esta ação removerá o resíduo."
          variant="outline"
          onConfirm={() => {
            props.confirmActionResult(props.item, 'excluir', true);
          }}
          onCancel={() => {
            props.confirmActionResult(props.item, 'excluir', false);
          }}
        />
      )}
    </Group>
  );
}
